import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import ContactUs from "../components/ContactUs";
const ContactPage = () =>{
    return(
        <div className="main-container">
            <NavBar/>
            <ContactUs/>
            <Footer/>
        </div>
    )
}
export default ContactPage